/**
 * Open the support chat from anywhere in the player UI.
 *
 * The widget registers window.__openSupportChat when it mounts. It may not
 * have mounted yet on a cold load, and it deliberately does not mount at all
 * on some routes, so this retries briefly and leaves a flag the widget
 * honours if the click landed first.
 *
 * The last resort is the support mailbox rather than nothing: this is what
 * the Help Center links call now that Zendesk is gone, and a dead link there
 * would leave a player with no way to reach anyone.
 */

const SUPPORT_EMAIL = "support@cluck.us";

export function openSupportChat() {
  if (typeof window === "undefined") return;

  const tryOpen = (attempt = 0) => {
    if (typeof window.__openSupportChat === "function") {
      window.__openSupportChat();
      return;
    }
    window.__pendingOpenSupport = true;
    if (attempt < 8) {
      setTimeout(() => tryOpen(attempt + 1), attempt < 4 ? 250 : 600);
      return;
    }
    // The chat is switched off, or suppressed on this route. Give the player
    // the mailbox, which reaches the same ticket queue.
    window.location.href = `mailto:${SUPPORT_EMAIL}`;
  };

  tryOpen();
}

export default openSupportChat;
